// src/api/apiClient.js
import axios from 'axios';
import { getAccessToken } from './auth';

const url_api = 'https://portfolio-backend-1-nmwf.onrender.com';


const apiClient = axios.create({
  baseURL: url_api,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor: add the current access token
// apiClient.interceptors.request.use(
//   async (config) => {
//     const token = localStorage.getItem('access');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Response Interceptor: refresh token if access token is expired
// apiClient.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     // If access token is invalid or expired and request hasn't been retried yet
//     if (
//       error.response?.status === 401 &&
//       !originalRequest._retry &&
//       localStorage.getItem('refresh')
//     ) {
//       originalRequest._retry = true;
//       try {
//         const newToken = await getAccessToken(); // refresh it
//         if (newToken) {
//           localStorage.setItem('access', newToken);
//           originalRequest.headers.Authorization = `Bearer ${newToken}`;
//           return apiClient(originalRequest); // retry the original request
//         }
//       } catch (err) {
//         console.error('Token refresh failed:', err);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

export default apiClient;
